import axios from 'axios'
import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { AuthContext, IAuthContext } from '../../../contexts/Auth'
import {
    ActionButton,
    Card,
    CardTitle,
    ErrorText,
    Input,
    Label,
    Muted,
    Row,
    SecondaryButton,
    Spacer,
} from '../../affiliate/ui'
import { SettingsFormProps } from './SettingsForm.types'

const CardBrand = styled.p`
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
`

const CardDigits = styled.p`
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.04em;
`

function SettingsForm({ toggleModal }: SettingsFormProps) {
    const { userInfo, setUserInfo } = useContext<IAuthContext>(AuthContext)
    const [error, setError] = useState('')
    const [saving, setSaving] = useState(false)
    const [formState, setFormState] = useState({
        email: userInfo?.email || '',
        phone: userInfo?.phone || '',
    })

    const dirty = formState.email !== (userInfo?.email || '') || formState.phone !== (userInfo?.phone || '')
    const hasCard = userInfo?.role === 'customer' && !!userInfo?.last4

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target
        setFormState((prev) => ({ ...prev, [name]: value }))
    }

    const save = async () => {
        setError('')
        setSaving(true)
        try {
            const { data } = await axios.patch(
                '/api/v1/users/@me',
                {
                    email: formState.email || userInfo.email,
                    phone: formState.phone || userInfo.phone,
                },
                { withCredentials: true }
            )
            setUserInfo(data)
        } catch (err) {
            setError(axios.isAxiosError(err) ? err.response?.data?.message || err.message : (err as Error).message)
        } finally {
            setSaving(false)
        }
    }

    return (
        <>
            <Card>
                <CardTitle>Account</CardTitle>
                <Label>
                    Email address
                    <Input
                        type="email"
                        name="email"
                        autoComplete="email"
                        onChange={handleChange}
                        value={formState.email}
                        placeholder="username@email.com"
                    />
                </Label>
                <Label>
                    Phone number
                    <Input
                        type="tel"
                        name="phone"
                        autoComplete="tel"
                        onChange={handleChange}
                        value={formState.phone}
                        placeholder="(123) 345-6789"
                    />
                </Label>
                {error && <ErrorText>{error}</ErrorText>}
                <Row>
                    <ActionButton disabled={!dirty || saving} onClick={save}>
                        {saving ? 'Saving…' : 'Save changes'}
                    </ActionButton>
                    {dirty && !saving && (
                        <SecondaryButton
                            onClick={() => {
                                setFormState({ email: userInfo?.email || '', phone: userInfo?.phone || '' })
                                setError('')
                            }}
                        >
                            Discard
                        </SecondaryButton>
                    )}
                </Row>
            </Card>

            <Card>
                <CardTitle>Payment method</CardTitle>
                {hasCard ? (
                    <Row>
                        <div>
                            <CardBrand>
                                {userInfo.brand} ending in {userInfo.last4}
                            </CardBrand>
                            <CardDigits>•••• •••• •••• {userInfo.last4}</CardDigits>
                        </div>
                        <Spacer />
                        <SecondaryButton onClick={toggleModal}>Change card</SecondaryButton>
                    </Row>
                ) : (
                    <Muted>No card on file.</Muted>
                )}
            </Card>
        </>
    )
}

export default SettingsForm
